/*
  Плашка «Счёт ждёт человека» над суммами карточки и возврат в автоматику.

  Решения владельца 06.10.2026. Пометку «нужен человек» ставит автоматика - спор
  о сумме, тяжёлая ситуация, просьба соединить с оператором, неразобранный итог
  разговора, - и до этого дня снять её было нечем: счёт выпадал из обзвона
  навсегда. Теперь:
  - плашка жёлтая, как «придержан», и стоит там же - над суммами;
  - вернуть можно только с комментарием: по нему видно, что человек счёт
    разобрал, и вывод встаёт строкой в «Историю» счёта;
  - пауза по заявлению должника и отказ от обращений возврат переживают - что
    это значит для обзвона сегодня, говорит фраза с сервера (`waiting`);
  - разобранное возражение уходит с карточки (блок `ContactState` исчезает) и
    встаёт в «Историю» рядом с выводом: над разобранным счётом оно сбивало с
    толку (второе решение владельца того же дня).

  Кнопку видят те же, кто видит «Позвонить», и она так же выключена в режиме
  только чтения.
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { Field, Notice } from './Common.jsx'
import Modal from './Modal.jsx'

export default function NeedsHumanNotice({ card, profile, onDone }) {
  const [open, setOpen] = useState(false)
  const waiting = card.contact_state?.waiting
  if (!waiting) return null

  const canAct = profile.permissions.includes('view_registry') && !profile.is_readonly
  return (
    <>
      <Notice kind="warn" wide>
        <div className="notice__what">{waiting}</div>
        <div className="notice__do">
          Разберитесь и верните счёт в автоматику - ваш вывод попадёт в историю счёта.{' '}
          {canAct ? (
            <button className="button button--quiet" type="button" onClick={() => setOpen(true)}>
              Вернуть в автоматику
            </button>
          ) : null}
        </div>
      </Notice>
      {open ? (
        <ReturnForm
          accountId={card.account_id}
          onClose={() => setOpen(false)}
          onReturned={() => {
            setOpen(false)
            onDone('Счёт возвращён в автоматику. Ваш вывод записан в историю счёта.')
          }}
        />
      ) : null}
    </>
  )
}

/*
  Окно возврата. Чек-лист формы (скилл frontend, правило 10): ошибка живёт
  внутри окна, успех закрывает его и перечитывает карточку, закрытие сбрасывает
  состояние - окно каждый раз создаётся заново.
*/
function ReturnForm({ accountId, onClose, onReturned }) {
  const [comment, setComment] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  const submit = async () => {
    setBusy(true)
    setError(null)
    try {
      await api.returnToAutomation(accountId, comment.trim())
      onReturned()
    } catch (failure) {
      setError(failure)
      setBusy(false)
    }
  }

  return (
    <Modal title="Вернуть счёт в автоматику" onClose={onClose} busy={busy}>
      <p className="modal__text">
        После возврата обзвон и сообщения снова будут включать этот счёт, а возражение должника
        уйдёт с карточки в историю счёта вместе с вашим выводом. Пауза по заявлению должника, если
        она идёт, сохранится до своего срока.
      </p>
      <Field label="Что выяснили и почему счёт можно снова обзванивать">
        <textarea
          className="field__input"
          rows={3}
          value={comment}
          onChange={(event) => setComment(event.target.value)}
        />
      </Field>
      <Notice error={error} />
      <div className="row row--tight">
        <button
          className="button"
          type="button"
          disabled={busy || !comment.trim()}
          onClick={submit}
        >
          Вернуть в автоматику
        </button>
        <button className="button button--quiet" type="button" onClick={onClose} disabled={busy}>
          Отмена
        </button>
      </div>
    </Modal>
  )
}
